const unionTerritoryStates = require('./config.js').configs.unionTerritoryStates;
const transactionForms = require('./config.js').configs.transactionForms;
const configs = require('./config.js').configs;
const defaultData = require('./default_data').data;
import domtoimage from 'dom-to-image';
import { Validator } from 'vee-validate';
import i18nPlugin, { loadLocale } from './plugins/i18n'

export const globalMixin =  {

    data(){
        return {
            platform: AndroidRoutingTest ? 'android' : 'desktop',
            bizOpsConfigs:{
                "email":"bizopsapp@gmail.com"
            },
            CurrentBusiness:null,
            Businesses:{ "BusinessList": null, "BusinessCount":0},
            TransactionSettings:{"businessId":null, "branchDivision":false, "beatRouteArea":false, "mrpWiseStock":false, "disableNegativeStock":false, "gstType":1},
            defaultBackupTime: {"hour":"11", "min":"00"},
            
            dashboard:{
                periodValue:"This Month",
                // startDate:new Date(),
                // endDate:new Date(),
                startDate:this.fn_getLocalDateFormat(),
                endDate:this.fn_getLocalDateFormat(), 
                defaultDateRange:'month'
            },

            minDateSelection:"2022-04-01",
            // maxDateSelection:"2024-03-31",
            maxDateSelection:"2027-03-31",
            isPremium:true,
            
            //for backup data
            backupInProgress:false,
            uploadStatus:null,

            //report data object1
            dataObj:{
              reportTitle:null,
              itemName:null,
              itemId:null,
              itemLabel:null,
              // startDate:new Date(), 
              // endDate:new Date(), 
              startDate:this.fn_getLocalDateFormat(), 
              endDate:this.fn_getLocalDateFormat(), 
              reportData:{"headerRow":null},
              columns:null,
              footerColumns:null,
              detailReportId:null,
              openView:false,
              reportType:null,
              tableView:false,
              reportPreferences:null,
              selectedAccountGroupTypeId:null,
              selectedPeriod:null,
              disableClick:false,
              hideFilterBtn:false,
              subReportData:null,
              subReportData2:null
            },

            reportFilterObj:{},
            reportFilters:null,
            invoicePrintColor:null,
            discardChanges:-1,
            snackbar_permission:true,
            permissionType:null,
            unsyncedItemsCount:null,
            appVersion:null,
            clientConnectionStatus:null,
            connectionTimer:null,
            connectionNumber:null,
            isAppUpdateAvailable:false,
            lastBackupBefore:0,
            lastBackupDate:null,
            ThermalPrintSettings:null,
            selectedLanguage:'en',
            invoicePrintInSelectedLanguage: localStorage.getItem('invoicePrintInSelectedLanguage') === '1',
            thermalPrintInSelectedLanguage: localStorage.getItem('thermalPrintInSelectedLanguage') === '1',
            shareInSelectedLanguage: localStorage.getItem('shareInSelectedLanguage') === '1',
            labelPrintLanguage:'zpl',
            LabelPrintSettings:null
        }
    },

    methods: {

        fn_getBusiness: function(path, businessStatusOld, callback){
            let self = this;
            this.getData('AllBusiness', null, {
                onSuccess: function(response){
                    console.log(response);
                    
                    let data  = JSON.parse(response);

                    // !callback ? AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({})) : '';

                    if(data){
                        self.CurrentBusiness = data.currentBusiness;

                        // patch for users who registered accountantant initially then registered their business and isAccountantOnly gone true because of code error
                        if(self.CurrentBusiness && self.CurrentBusiness.IsAccountantOnly && self.CurrentBusiness.GSTRegistrationStatus && (self.CurrentBusiness.GSTRegistrationStatus == 1 || self.CurrentBusiness.GSTRegistrationStatus == 2 || self.CurrentBusiness.GSTRegistrationStatus == 3)){
                            self.CurrentBusiness.IsAccountantOnly = false;
                        }
                        // end of patch

                        self.Businesses.BusinessList = data.businessList;
                        self.Businesses.BusinessCount = data.businessCount;
                        // data.openingDate ? self.fn_assignMinDateSelection(data.openingDate) : '';

                        // if(self.CurrentBusiness.UserType == 1){
                        if(!self.CurrentBusiness.IsAccountantOnly){
                            self.fn_setMinTransactionDate();

                            if(businessStatusOld && businessStatusOld != self.CurrentBusiness.GSTRegistrationStatus){
                                self.fn_updateTtf();
                            }

                            self.fn_getTransactionSettings();
                        }
                        
                        // if(path=='actions'){
                        //     if(callback){
                        //         callback();
                        //     }
                        //     else{
                        //         self.CurrentBusiness.UserType == 2 ? self.$router.replace('/accountant') : self.$router.replace('/actions');
                        //     }
                        //     // callback ? callback() : self.$router.replace('/actions');
                        // }
                        // else if(path=='goback'){
                        //   self.$router.go(-1);
                        // }
                        // else{
                        //     callback ? callback() : '';
                        // }

                        if(self.CurrentBusiness && self.CurrentBusiness.DataDrive){
                            self.fn_getLastBackupInfo();  
                        }

                        if(path=='goback'){
                          self.$router.go(-1);
                        }
                        else{
                            callback ? callback() : '';
                        }
                        
                    }
                    else{
                        console.log('Unable to load business');
                        self.showToast('Something went wrong. Try again');
                    }
                },
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_getLastBackupInfo: function(){
            let self = this;
            this.getData('BackupTime', this.$root.CurrentBusiness.BusinessID, 
                {
                    onSuccess: function(response){
                        console.log(response);

                        // setTimeout(() => {
                        //     self.$eventHub.$emit('DataBackupDialog');
                        // }, 5000);  
                        let l_date = JSON.parse(response);

                        if(l_date){
                            self.lastBackupDate = new Date(l_date);
                            let dateNow = new Date();
                            self.lastBackupBefore = parseInt((dateNow - self.lastBackupDate) / (1000 * 60 * 60 * 24), 10); 
                        }
                        else{
                            self.lastBackupDate = null;
                        }

                        if(!self.lastBackupDate || self.lastBackupBefore >= 4){

                            
                            self.fn_getAppOpenCountSinceFullBackup();

                            // let isBackupRunning = true;

                            // let backupCheckInterval = setInterval(() => {
                            //     isBackupRunning = JSON.parse(AndroidRoutingTest.isBackupRunning());
                            //     if(!isBackupRunning){
                            //         clearInterval(backupCheckInterval);
                            //         self.$eventHub.$emit('DataBackupDialog');
                            //     }
                            // }, 1000);
                        }

                        // self.lastBackupDate = null;

                    }, 
                    onError: function(error){
                        console.log(error);
                    }, 
                }
            );
        },

        fn_getAppOpenCountSinceFullBackup: function(){
            let self = this;
            this.getData('AppOpenCountSinceFullBackup', null, 
                {
                    onSuccess: function(response){
                        console.log('app open count');
                        console.log(response);
                        let appOpenCount = response ? Number(response) : 0;

                        let isBackupRunning = true;

                        let backupCheckInterval = setInterval(() => {
                            isBackupRunning = JSON.parse(AndroidRoutingTest.isBackupRunning());
                            if(!isBackupRunning){
                                clearInterval(backupCheckInterval);
                                self.$eventHub.$emit('DataBackupDialog', {'appOpenCount':appOpenCount});
                            }
                        }, 1000);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }, 
                }
            );
        },

        // for quantity 8 digits and 3 decimals
        fn_boundDecimalLength: function(obj, inputfn, key){
            this.$nextTick(() => {
                let decimalIndex = obj[key].indexOf('.');

                let intVal = null;
                if(decimalIndex != -1){
                    intVal = obj[key].substr(0, obj[key].indexOf('.'));
                }
                else{
                    intVal = obj[key];
                }
                
                let intValue = null;
                if(intVal.length > 8){
                    intValue = intVal.slice(0, 8);
                    this.showToast("Max 8 digits is allowed in quantity field");
                }
                else{
                    intValue = intVal;
                }
                
                if(obj[key].indexOf('.') != -1){
                    let decVal = obj[key].substr(obj[key].indexOf('.')+1);
                    decVal.length > 3 ? this.showToast("Max 3 decimal places is allowed in quantity field") : '';
                    let decimalValue = decVal.slice(0, 3);
                    obj[key] = intValue ? intValue + '.' + decimalValue : '.' + decimalValue;
                }
                else{
                    obj[key] = intValue;
                }

                this.$forceUpdate();

                inputfn ? inputfn(obj) : '';
            })
        },

        // only for 2 decimals
        fn_boundDecimalLengthUpto2: function(obj, key){
            this.$nextTick(() => {
                let decimalIndex = obj[key].toString().indexOf('.');
                if(decimalIndex != -1){
                    let intVal = obj[key].toString().split('.')[0];
                    let decVal = obj[key].toString().split('.')[1];
                    obj[key] = Number(intVal + '.' + decVal.slice(0, 2));
                }
            })
        },

        fn_boundDecimalLengthUpto4: function(obj, key){
            this.$nextTick(() => {
                let decimalIndex = obj[key].toString().indexOf('.');
                if(decimalIndex != -1){
                    let intVal = obj[key].toString().split('.')[0];
                    let decVal = obj[key].toString().split('.')[1];
                    obj[key] = Number(intVal + '.' + decVal.slice(0, 4));
                }
            })
        },
        // fn_assignMinDateSelection: function(openingDate){
        //     let year = this.$moment(openingDate).format('YYYY');
        //     let month = this.$moment(openingDate).format('MM');
        //     let day = this.$moment(openingDate).format('DD');
        //     this.minDateSelection = year+"-"+month+"-"+day;
        // },

        // transaction min selection date
        fn_setMinTransactionDate: function(){
            // let year = this.$moment(this.openingDate).format('YYYY');
            // let month = this.$moment(this.openingDate).format('MM');
            // let day = this.$moment(this.openingDate).format('DD');
            let year = this.$moment(this.CurrentBusiness.OpeningDate).format('YYYY');
            let month = this.$moment(this.CurrentBusiness.OpeningDate).format('MM');
            let day = this.$moment(this.CurrentBusiness.OpeningDate).format('DD');

            this.minDateSelection = year+"-"+month+"-"+day;
        },

        fn_getTransactionSettings: function(callback){
            let self = this;
            this.getData('TransactionSettings', this.CurrentBusiness.BusinessID, 
              {
                onSuccess: function(response){
                    console.log(response);
                    response!='null' ? self.TransactionSettings = JSON.parse(response) : '';
                    !self.TransactionSettings.businessId ? self.TransactionSettings.businessId = self.CurrentBusiness.BusinessID : '';

                    if(self.TransactionSettings && self.TransactionSettings.additionalData){
                        self.TransactionSettings = JSON.parse(self.TransactionSettings.additionalData);
                    }

                    // patch for type wise number series
                    let data = JSON.parse(response);
                    if(data.typeWiseNumberSeries != undefined){
                        self.TransactionSettings.typeWiseNumberSeries = data.typeWiseNumberSeries;
                    }
                  
                    if(callback){
                        callback();
                    }
                    else{
                        self.fn_getBusinessLogo();
                    }
                },
                onError: function(error){
                    console.log(error);
                }
              }
            );
        },

        fn_getBusinessLogo: function(){
            let self = this;
            this.getData('BusinessLogo', this.CurrentBusiness.BusinessID, 
              {
                onSuccess: function(response){
                    console.log(response);
                    self.CurrentBusiness.businessLogo = response;   
                },
                onError: function(error){
                    console.log(error);
                }
              }
            );
        },

        fn_getGstType: function(partyStateId, partyGstType, importExport){
            // let stateId = partyStateId ? partyStateId : this.CurrentBusiness.StateID;
            if(this.CurrentBusiness.StateID){
            
                let ut = false;

                for(let i=0; i<unionTerritoryStates.length; i++){
                    if((unionTerritoryStates[i].id == this.CurrentBusiness.StateID) && (partyStateId == this.CurrentBusiness.StateID)){
                        ut = true;
                        break;
                    }
                }

                if(ut && !importExport)
                    return "UnionTerritory"

                else if(partyStateId == this.CurrentBusiness.StateID && (partyGstType!=configs.accountGstType.overseas.id && partyGstType!=configs.accountGstType.sez.id))
                    return "IntraState"

                else
                    return "InterState"
            }
              
            return null;
        },

        fn_removeTempDrafts: function(){
            let self = this;
            this.deleteData('RemoveDraftByType', 'temp', {
                onSuccess: function(response){
                    console.log(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_getStatus: function(response){
            let status = JSON.parse(response);
            this.showToast(status.Message);
        },

        fn_autoBackupTime: function(time){
            let date = new Date();
            date.setHours(time.hour);
            date.setMinutes(time.min);
            return date;
        },

        fn_sendToAndroidTransactionListIds: function(){
            let obj = {};
            for(let i in transactionForms){
                let key = JSON.stringify(transactionForms[i].id);
                obj[key] = transactionForms[i].title;
            }
            // console.log(JSON.stringify(obj));
            AndroidRoutingTest.setTransactionListIds(JSON.stringify(obj));
        },

        fn_bottomNavigationItemClick: function (tagId, menuId, menuAction) {
            if(menuAction=='reports'){
                // this.$router.push({path:'/'+this.CurrentBusiness.BusinessID+'/reports'})
                this.$router.push({path:'/dashboard'});
            }
            else if(menuAction=='activity'){
                this.$router.push({path:'/activity'})
            }
            else if(menuAction=='actions'){
                this.$router.push({path:'/actions'})
            }
            else if(menuAction=='notifications'){
                this.$router.push({path:'/notifications'})
            }
            else if(menuAction=='settings'){
                this.$router.push({path:'/settings'})
            }
        },

        fn_pushDefaultJson: function(callback){
            var self = this;
            // let dataObj = require('./default_data').data;
            let dataObj = JSON.parse(JSON.stringify(defaultData));
            dataObj.defaultDataJson.transactionSettings[0].businessId = this.CurrentBusiness.BusinessID;
            dataObj.defaultDataJson.godowns[0].stateId = this.$root.CurrentBusiness.StateID;
            this.postData('DefaultData', dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_getTransactionSettings();
                        // callback();
                        if(self.CurrentBusiness.GSTRegistrationStatus != 1){
                            self.fn_updateTtf(callback);
                        }
                        else{
                            callback();
                        }

                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_updateTtf: function(callback){
            let postObj = {};
            postObj.transactionTypeId = ["10003"];
            postObj.transactionTypeForms = [];
            if(this.CurrentBusiness.GSTRegistrationStatus==1){
                // postObj.transactionTypeForms = [];
                postObj.title = 'Tax Invoice';

                // postObj.fieldId = "5b9dcbb4-697f-4115-ac86-79c3cb064617";
                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":null});

                // postObj.transactionType = {"id":configs.statusUpdate.transactionTypeForm.expense.id, "name":"ITC Not Eligible", "title":"ITC Not Eligible"};
                for(let i=0; i<defaultData.defaultDataJson.transactionsType.length; i++){
                    let obj = {};
                    obj.transactionTypeFormId = defaultData.defaultDataJson.transactionsType[i].transactionTypeFormId;
                    obj.taxMode = defaultData.defaultDataJson.transactionsType[i].taxMode;

                    if(defaultData.defaultDataJson.transactionsType[i].transactionTypeFormId == configs.statusUpdate.transactionTypeForm.expense.id){
                        // obj.name = "ITC Not Eligible";
                        // obj.title = "ITC Not Eligible";
                        obj.name = "Expense";
                        obj.title = "Expense";
                    }
                    postObj.transactionTypeForms.push(obj);
                }

                this.fn_updateTtfRegister(callback, postObj)
            }
            else if(this.CurrentBusiness.GSTRegistrationStatus==2){
                postObj.title = 'Bill of Supply';
                postObj.taxMode = 0;

                // postObj.fieldId = "5b9dcbb4-697f-4115-ac86-79c3cb064617";
                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":"Composition Taxable Person"});

                // postObj.transactionType = {"id":configs.statusUpdate.transactionTypeForm.expense.id, "name":"Expense", "title":"Expense"};
                let obj = {};
                obj.transactionTypeFormId = configs.statusUpdate.transactionTypeForm.expense.id;
                obj.name = "Expense";
                obj.title = "Expense";
                postObj.transactionTypeForms.push(obj);

                this.fn_updateTtfOther(callback, postObj);
            }
            else if(this.CurrentBusiness.GSTRegistrationStatus==3){
                postObj.title = 'Invoice';
                postObj.taxMode = 0;

                // postObj.fieldId = "5b9dcbb4-697f-4115-ac86-79c3cb064617";
                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":null});

                // postObj.transactionType = {"id":configs.statusUpdate.transactionTypeForm.expense.id, "name":"Expense", "title":"Expense"};
                let obj = {};
                obj.transactionTypeFormId = configs.statusUpdate.transactionTypeForm.expense.id;
                obj.name = "Expense";
                obj.title = "Expense";
                postObj.transactionTypeForms.push(obj);

                this.fn_updateTtfOther(callback, postObj);
            }
        },

        fn_updateTtfRegister: function(callback, postObj){
            console.log(JSON.stringify(postObj));
            this.postFilterData('UpdateTtfToRegister', null, postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_updateTtfOther: function(callback, postObj){
            this.postFilterData('UpdateTtfToOther', null, postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_deviceDeactivated: function(){
            localStorage.removeItem('bottomNavigationSet');
            this.showToast('This business has been activated in another device');
            // this.$router.replace({path:'/registration/business/login'});
        },

        fn_init: function(){
            //setting setBottomNavtion to false
            localStorage.setItem('bottomNavigationSet', 0);
            this.fn_sendToAndroidTransactionListIds();
            this.fn_getUqc();
            this.fn_removeTempDrafts();
            this.fn_getUserType();
        },

        fn_navigateToDisplayView: function(transactionListId, itemId){

            let viewName = '';

            if(transactionListId==10001 || transactionListId==10002 || transactionListId==10003 || transactionListId==10004 || transactionListId==10005){
              viewName = 'sales/';
            }
            else if(transactionListId==20001 || transactionListId==20002 || transactionListId==20003 || transactionListId==20004 || transactionListId==20005){
              viewName = 'purchase/';
            }
            else if(transactionListId==40001 || transactionListId==40002 || transactionListId==40003 || transactionListId==40004 || transactionListId==40005 || transactionListId==40006){
              viewName = 'inventory/';
            }

            for(let i=0; i<transactionForms.length; i++){
              if(transactionForms[i].id == transactionListId){
                viewName += transactionForms[i].title.toLowerCase().replace(/ /g,'');
                break;
              }
            }

            this.$router.push('/transactions/'+viewName+'/items/'+itemId);
        },

        fn_getPhoneNumber: function(token, callback){
            if(!navigator.onLine){
                this.showToast('Internet not available');
                this.hideLoading();
                return;
            }

            // this.showLoading("Please wait...");
                
            let self = this;
            let filterObject = {};
            filterObject.businessId = this.CurrentBusiness.BusinessID;
            filterObject.token = token;

            if(!token){
                console.log("Token not found");
                this.showToast("Something went wrong. Try again!.");
                return;
            }

            this.getServerData('GetPhoneNumber', filterObject, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let data = JSON.parse(response);
                        callback(data.PhoneNumber);
                        // self.hideLoading();
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        if(typeof JSON.parse(error) == 'object'){
                            let response = JSON.parse(error);
                            self.showToast(response.Message);
                        }
                    }, 
                }
            );
        },

        numberToLocale: function(value, withoutDecimal){
            // return value ? value.toLocaleString("hi-IN") : 0;
            let indianFormatValue = value ? value.toLocaleString("hi-IN") : 0;
            if(indianFormatValue){
                if(indianFormatValue.split('.').length == 1){
                    return withoutDecimal ? indianFormatValue : indianFormatValue + '.00';
                }
                else{
                    if(indianFormatValue.split('.')[1].length == 1){
                        return indianFormatValue + "0";
                    }
                    else{
                        return indianFormatValue;
                    }
                }
            }
            else{
                return indianFormatValue;
            }
        },

        fixed2Decimal: function(value){
            return value ? value.toFixed(2) : 0;
        },

        fn_getAuthToken: function(callback){
            if(!navigator.onLine){
                this.showToast('Internet not available');
                this.hideLoading();
                return;
            }
            
            let self = this;
            this.getData('GetToken', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.showToast("Something went wrong. Try again!.");
                        self.hideLoading();
                    }
                }
            );
        },

        fn_getBlankChars: function(val){
            let stringLen = val.length;
            let blankCharCount = Math.round((38 - stringLen) / 2);
            return blankCharCount;
        },

        fn_generateImage: function(item){

            this.showLoading("Please wait...");

            // let node = document.getElementById('reminder_node1');
            // let plainText = node.innerText.replace(/<[^>]*>/g, '');
            // console.log(plainText);

            // return

            let node = document.getElementById('reminder_node');
            node.style.position = 'inherit';
            node.style.top = 'auto';
            
            let self = this;

            let scale = 5;
            let style = {
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
                width: node.clientWidth + 'px', // use original width of DOM element to avoid part of the image being cropped out
                height: node.clientHeight + 'px' // use original height of DOM element
            };

            let width = node.clientWidth * scale;
            let height = node.clientHeight * scale;

            domtoimage.toPng(node, {width: width, height: height, style: style }).then(function (dataUrl) {

                node.style.position = 'absolute';
                node.style.top = '-9999px';

                self.hideLoading();

                let shareObj = {};
                shareObj.type = "image"
                shareObj.shareType = "share"
                // shareObj.primaryMobileNumber = item.primaryMobileNumber ? item.primaryMobileNumber : null;
                shareObj.primaryMobileNumber = item.primaryMobileNumber ? item.primaryMobileNumber.trim() : null;
                shareObj.email = item.email ? [item.email] : null;
                shareObj.subject = "Payment Reminder";
                shareObj.textMessage = self.$tShare('share.paymentReminderShort', {
                    amount: self.numberToLocale(self.roundUpto2Decimals(item.amount))
                });
                shareObj.base64String = dataUrl.substring(dataUrl.indexOf(',') + 1);
                // document.getElementById("reminder_node").style.top = "-9999px";
                self.fn_share(shareObj);
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
        },

        fn_sendPaymentReminder: function(item, canvasId){

            let canvas = document.getElementById(canvasId);
            let ctx = canvas.getContext("2d");
            ctx.font = "16px Arial";
            ctx.fillStyle = "red";
            ctx.fillText("Payment Reminder",16,32);

            ctx.fillStyle = "#444";
            ctx.fillText("Sent Via",325,32);
            ctx.fillStyle = "#4b77be";
            ctx.fillText("BizOps App",300,56);

            ctx.fillStyle = "#444";
            ctx.fillText("As on "+ this.$moment(new Date()).format('DD-MMM-YYYY'),16,64);
            ctx.fillStyle = "green";
            ctx.fillText("₹ "+this.numberToLocale(this.roundUpto2Decimals(item.amount)),16,96);

            ctx.fillStyle = "#999";
            ctx.fillText(this.CurrentBusiness.BusinessName,16,144);
            ctx.fillStyle = "#999";
            let phoneNumber = '+91-'+this.CurrentBusiness.BusinessProfileNumber.substr(2,this.CurrentBusiness.BusinessProfileNumber);
            ctx.fillText("Ph: "+phoneNumber,16,168);

            let dataURL = canvas.toDataURL();
            console.log(dataURL);
            let shareObj = {};
            shareObj.type = "image"
            shareObj.shareType = "share"
            shareObj.primaryMobileNumber = item.primaryMobileNumber ? item.primaryMobileNumber.trim() : null;
            shareObj.email = item.email ? [item.email] : null;
            shareObj.subject = "Payment Reminder";
            shareObj.textMessage = this.$tShare('share.paymentReminderShort', {
                amount: this.numberToLocale(this.roundUpto2Decimals(item.amount))
            });
            shareObj.base64String = dataURL.substring(dataURL.indexOf(',') + 1);

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            
            this.fn_share(shareObj);
        },

        fn_share: function(shareObj){
            var self = this;

            if(shareObj.primaryMobileNumber && shareObj.primaryMobileNumber.length == 10 && shareObj.primaryMobileNumber.substring(0, 2) != 91){
                // shareObj.primaryMobileNumber = '91'+ shareObj.primaryMobileNumber.trim();
                shareObj.primaryMobileNumber = '91' + shareObj.primaryMobileNumber.replace(/\s+/g, "");
            }
            else{
                if(shareObj.primaryMobileNumber){
                    shareObj.primaryMobileNumber = shareObj.primaryMobileNumber.replace(/\s+/g, "");
                }
            }

            if(shareObj.primaryMobileNumber && shareObj.primaryMobileNumber.indexOf('+') == 0){
                shareObj.primaryMobileNumber = shareObj.primaryMobileNumber.substring(1);
            }

            if(shareObj.primaryMobileNumber && shareObj.primaryMobileNumber.substring(0, 2) != 91){
                shareObj.primaryMobileNumber = '91' + shareObj.primaryMobileNumber;
            }

            // let fName = shareObj.shareType == 'sharewhatsapp' ? 'Share' : 'ShareOther';
            let fName = shareObj.shareType == 'share' ? 'Share' : 'ShareOther';

            this.postData(fName, shareObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        if(shareObj.subject){
                            // let details = shareObj.subject ? shareObj.subject.replace(" ", "_") : shareObj.transactionNumber;
                            let postObj = {
                                "eventName": shareObj.shareType == 'share' ? 'share_whatsapp_transaction' : 'share_other_transaction',
                                "eventData":[
                                    {"eventKey":"BusinessId","eventValue":self.$root.CurrentBusiness.BusinessID},
                                    {"eventKey":"TransactionId","eventValue":''},
                                    {"eventKey":"TransactionNumber","eventValue":shareObj.transactionNumber ? shareObj.transactionNumber : ''},
                                    {"eventKey":"TransactionForm","eventValue":''},
                                ]
                                // "eventName": shareObj.shareType == 'share' ? 'share_whatsapp' : 'share_other',
                                // "eventData":[
                                //     {"eventKey":"share_details","eventValue":details}
                                // ]
                            }
        			        self.$root.fn_postMetrics(postObj);
                        }
                    },
                    onError: function(error){
                        console.log(error);
                        self.showToast('Failed to share');
                    }
                }
            );
        },

        fn_checkStoragePermission: function(callback){
            var self = this;
            this.getData("CheckStoragePermission", null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback();
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.showToast("Please allow storage permission");
                    }
                }
            );
        },

        fn_checkLocationPermission: function(callback){
            var self = this;
            this.getData("CheckLocationPermission", null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback();
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.showToast("Please allow location permission");
                    }
                }
            );
        },

        fn_checkCameraPermission: function(callback){
            var self = this;
            this.getData("CheckCameraPermission", null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback();
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.showToast("Please allow camera permission");
                    }
                }
            );
        },

        fn_gotoPermissionSettings: function(){
            this.getData('ShowPermissionSettings', this.permissionType, {
                onSuccess: function(response){
                  console.log(response);
                }, 
                onError: function(error){
                  console.log(error);
                }
            });
        },

        fn_startSync: function(){
            this.getData('StartInstaSync', this.CurrentBusiness.BusinessID, 
            {
                onSuccess: function(response){
                  console.log(response);
                }, 
                onError: function(error){
                  console.log(error);
                }
            });
        },

        fn_setUploadStatus: function(status){
            this.uploadStatus = status;
        },

        // fn_getMigrationData: function(oldVersion, newVersion){
        //     console.log('migration data');
        //     console.log(oldVersion);
        //     console.log(newVersion);

        //     let oldVer = new Number(oldVersion) + 1;
        //     let newVer = new Number(newVersion);
        //     let self = this;

        //     for(let i=oldVer; i<newVer; i++){
        //         (function(ver){
        //             let migrationData = require('./migration_data').data["version"+ver];
        //             console.log(JSON.stringify(migrationData));
        //             let data = null;
        //             if(migrationData){
        //                 if(migrationData.isQuery){
        //                     data = {"dataQuery":migrationData.data};
        //                     self.fn_postMigrationQuery(data, ver, newVer);
        //                 }
        //                 else{
        //                     data = migrationData.data;
        //                     self.fn_postMigrationData(data, ver, newVer);
        //                 }
        //             }
        //             else{
        //                 console.log("version"+ver+" has no data for migration" );
        //                 if((ver+1) == newVer){
        //                     self.fn_postWebVersion(newVer);
        //                 }
        //             }
        //         }(i))
        //     }
        // },

        // fn_postMigrationQuery: function(dataObj, ver, newVer){
        //     var self = this;
        //     this.postFilterData("PostMigrationQuery", null, dataObj, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 console.log("Data migration done");
        //                 if((ver+1) == newVer){
        //                     self.fn_postWebVersion(newVer);
        //                 }
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 console.log("Error in data migration");
        //             }
        //         }
        //     );
        // },

        // fn_postMigrationData: function(dataObj, ver, newVer){
        //     var self = this;
        //     this.postData("MigrationData", dataObj, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 console.log("Data migration done");
        //                 if((ver+1) == newVer){
        //                     self.fn_postWebVersion(newVer);
        //                 }
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 console.log("Error in data migration");
        //             }
        //         }
        //     );
        // },

        // fn_postWebVersion: function(ver){
        //     var self = this;
        //     let postObj = {};
        //     postObj.version = ver;
        //     postObj.businessId = this.CurrentBusiness.BusinessID;
        //     this.postData('PostWebVersion', postObj, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 console.log("Post web version done");
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 console.log("Error in post web version");
        //             }
        //         }
        //     );
        // },

        fn_getUqc:function(uqc){
            let obj = {};
            for(let i in configs.unitQuantityCodes){
                let key = JSON.stringify(configs.unitQuantityCodes[i].id);
                obj[key] = configs.unitQuantityCodes[i].name;
            }
            // console.log(JSON.stringify(obj));
            AndroidRoutingTest.setUqc(JSON.stringify(obj));
        },

        fn_openDownloadedFile: function(){
           AndroidRoutingTest.openDownloadedFile();
        },

        fn_deepEqual(object1, object2) {
            const keys1 = Object.keys(object1);
            const keys2 = Object.keys(object2);

            if (keys1.length !== keys2.length) {
                // this.discardChanges == -1 ? this.discardChanges = 0 : '';
                // if(this.discardChanges==0){
                //     return false;
                // }
                // else{
                //     this.discardChanges = -1;
                //     return true;
                // }
                return false;
            }

            for (const key of keys1) {
                const val1 = object1[key];
                const val2 = object2[key];
                const areObjects = this.isObject(val1) && this.isObject(val2);
                if (areObjects && !this.fn_deepEqual(val1, val2) || !areObjects && val1 !== val2) {
                    // this.discardChanges == -1 ? this.discardChanges = 0 : '';
                    // if(this.discardChanges==0){
                    //     return false;
                    // }
                    // else{
                    //     this.discardChanges = -1;
                    //     return true;
                    // }
                    return false;
                }
            }

            // this.discardChanges = -1;
            return true;
        },

        isObject(object) {
          return object != null && typeof object === 'object';
        },

        fn_copyFormObject: function(formObj, formId){
            if(!localStorage.getItem(formId)){
                localStorage.setItem(formId, JSON.stringify(formObj));
            }
        },

        fn_getFormObject: function(formId){
            return localStorage.getItem(formId);
        },

        fn_deleteFormObject: function(formId){
            localStorage.removeItem(formId);
        },

        // fn_showSnackbarUnreadTickets: function(ticketCount, supportTicketID){
        //     console.log(ticketCount);
        //     if(ticketCount){
        //         let unreadTicketObj = {};
        //         unreadTicketObj.ticketCount = Number(ticketCount);
        //         unreadTicketObj.supportTicketID = supportTicketID;
        //         this.$eventHub.$emit('ShowNotificationBar', unreadTicketObj);    
        //     }
        // },

        fn_showSnackbarUnreadTickets: function(ticketCount, supportTicketID){
            console.log(ticketCount);
            if(ticketCount){
                let unreadTicketObj = {};
                unreadTicketObj.ticketCount = Number(ticketCount);
                unreadTicketObj.supportTicketID = supportTicketID;
                this.$eventHub.$emit('ShowNotificationBar', unreadTicketObj);    
            }
        },

        fn_openSupport: function(type, ticketCount, ticketId){

            if(this.$root.CurrentBusiness.temporaryBusiness && type == 'customer'){
                this.showToast('Remove temporary business to open user support');
                return;
            }

            if(!navigator.onLine){
              this.showToast('Internet not available');
            }

            var self = this;
            let postObj = {};

            if(type == 'support'){
                postObj.url = process.env.SUPPORT_APP_URL + "/support/supportteam/items?businessid="+this.$root.CurrentBusiness.BusinessID;
            }
            else if(type == 'customer'){
                postObj.url = process.env.SUPPORT_APP_URL + "/support/appsupport/tickets/items?businessid="+this.$root.CurrentBusiness.BusinessID;
            }

            this.postData('ShowSupportView', postObj,
            {
                onSuccess: function(response){
                  console.log(response);
                },
                onError: function(error){
                  console.log(error);
                  self.showToast('Something went wrong. Try again!.');
                }
            });
        },

        fn_payOrReceive: function(type, groupTypeId){
            if(groupTypeId==103){
                return type == 1 ? 'Positive' : 'Negative';
            }
            else{
                return type == 1 ? 'To Receive' : 'To Pay';
            }
        },

        fn_internetStatus: function(){
            if(!navigator.onLine){
                return false;
            }
            else{
                return true;
            }
        },

        fn_changeDriveAlert: function(driveToSelect){
            console.log(driveToSelect);
            if(driveToSelect){
                let dataDriveObject = {};
                dataDriveObject.dataDriveToSelect = driveToSelect;
                this.$eventHub.$emit('ShowChangeDriveAlert', dataDriveObject); 
            }
        },

        fn_openDialogChangeDrive: function(){
            var self = this;
            this.getData('SetBusinessDataDrive', this.$root.CurrentBusiness.DataDrive, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_showDialogStorageFull: function(requireSize){
            console.log('show dialog storage full');
            let alertObj = {};
            alertObj.requireSize = requireSize && requireSize != 'null' ? requireSize : '';
            this.$eventHub.$emit('ShowDialogAlert', alertObj); 
        },

        fn_showAlert: function(type, callFromInside){
            console.log('show dialog alert');

            if(callFromInside && localStorage.getItem('donotaskfornotification')){
                localStorage.removeItem('donotaskfornotification');
            }
            
            let alertObj = {};
            alertObj.type = type;
            this.$eventHub.$emit('ShowAlert', alertObj); 
        },

        fn_openPermissionDialog: function(permissionType){
            console.log('show dialog alert');
            this.permissionType = permissionType;
            this.$eventHub.$emit('PermissionDialog');
        },

        fn_unsyncedItems: function(count, isSyncPending){
            console.log(count);
            console.log(isSyncPending);
            this.unsyncedItemsCount = Number(count);
            // if(JSON.parse(isSyncPending) && this.unsyncedItemsCount){
            //     let alertObj = {};
            //     alertObj.count = this.unsyncedItemsCount;
            //     this.$eventHub.$emit('ShowSyncAlert', alertObj);  
            // }
        },

        fn_updateMismatchDataDrive: function(dataDrive){
            this.$root.CurrentBusiness.DataDrive = dataDrive;
        },

        fn_getCurrentDateTimeString: function(){
            let isoDateString = new Date().toISOString();
            let date = isoDateString.substring(0, isoDateString.indexOf('T')).replace(/-/g,'');
            let localTimeString = new Date().toLocaleTimeString().replace(/:/g,'');
            // let time = new Date().toLocaleTimeString().replace(/:/g,'');
            let time = localTimeString.substring(0, localTimeString.indexOf(' '));
            let milliSeconds = new Date().getMilliseconds();
            return date + time + milliSeconds;
        },

        fn_getLocalDateFormat: function(dateObj){
            let now = dateObj ? new Date(dateObj) : new Date();
            let year = now.getFullYear();
            let month = ("0" + (now.getMonth()+1)).slice(-2);
            let date = ("0" + now.getDate()).slice(-2);
            let time = now.toTimeString().substring(0, now.toTimeString().indexOf(' '));
            return year + '-' + month + '-' + date + 'T' + time + '.' + now.getMilliseconds();
        },

        fn_abbreviatedBusinessName: function(){
            let words = this.CurrentBusiness.BusinessName.trim().split(' ');

            if(words.length > 1){
                return words[0][0].toUpperCase() + words[1][0].toUpperCase();    
            }
            else{
                return words[0][0].toUpperCase();
            }
            
        },

        fn_abbreviatedName: function(str){
            let words = str.trim().split(' ');

            if(words.length > 1){
                return words[0][0].toUpperCase() + words[1][0].toUpperCase();    
            }
            else{
                return words[0][0].toUpperCase();
            }
            
        },

        fn_testAlert: function(){
            let alertObj = {};
            this.$eventHub.$emit('alertTest', alertObj);   
        },

        fn_webRtcConnectionDetails: function(){
            this.$router.push({path:"/settings/connectiondetails"});
        },

        // only for this fiscal year
        fn_getMinSelectionDate: function(){
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth() + 1;

            let minDate = new Date(this.minDateSelection);

            if(currentDate > minDate){
            //   if(currentDate.getFullYear() >= minDate.getFullYear() && currentMonth>3){
              if(currentDate.getFullYear() >= minDate.getFullYear()){
                if(currentMonth>3){
                    return new Date(currentDate.getFullYear()+"/04/01");
                }
                else{
                    if(minDate.getFullYear() < currentDate.getFullYear() && (minDate.getMonth() + 1) <= 3){
                        return new Date(minDate.getFullYear()+"/04/01");
                    }
                    else{
                        return new Date(this.minDateSelection);
                    }
                    // return new Date((currentDate.getFullYear()-1)+"/04/01");
                }
                // return new Date(currentDate.getFullYear()+"/04/01");
              }
              else{
                // if(minDate.getMonth() + 1 <= 3){
                if(minDate.getFullYear() < currentDate.getFullYear() && (minDate.getMonth() + 1) <= 3){
                    return new Date(minDate.getFullYear()+"/04/01");
                }
                else{
                    return new Date(this.minDateSelection);
                }
              }
            }
            else{
              return new Date(this.minDateSelection);
            }
        },

        fn_getUserType : function(){
            this.getData('UserType', null, 
                {
                    onSuccess: function(response){
                        if(response === "Normal" && process.env.NODE_ENV === 'production'){
                            console.log = function () {};
                        }
                  }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_openExternalUrl: function(url){
            AndroidRoutingTest.openBrowser(url);
        },

        // saving to local cache
        fn_saveLocalData: function(dataObj){
            this.postData("LocalData", dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        // getting from local cache
        fn_getLocalData: function(key, callback){
            this.getData("LocalData", key, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback(response) : '';
                    },
                    onError: function(error){
                        console.log(error);
                        key == 'appLanguage' ? callback('en') : '';
                    }
                }
            );
        },

        // saving to table
        fn_saveLocalItem: function(dataObj, callback){
            this.postData("LocalItem", dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        // getting from table
        fn_getLocalItem: function(key, callback){
            this.getData("LocalItem", key, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback(response) : '';
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_broadcast: function(type){
            if(type === 'UpdateBusinessDirect'){
                this.fn_getBusiness(null, this.CurrentBusiness.GSTRegistrationStatus);
            }
        },

        fn_firstInvoiceCreated: function(){
            if(localStorage.getItem('first_invoice_added')){
                return true;
            }
            else{
                return false;
            }
        },

        fn_postMetrics: function(postObj, type){
            let businessCreatedDate = new Date(this.CurrentBusiness.CreatedOn);

            if(businessCreatedDate.toDateString() == new Date().toDateString()){
                postObj.eventData.push({"eventKey":"new_user", "eventValue":"yes"});
            }

            if(String.prototype.replaceAll){
                postObj.eventName = postObj.eventName.replaceAll(" ", "_");
            }
            else{
                postObj.eventName.replace(new RegExp(" ", 'g'), "_");
            }
            
            this.postData("FirebaseAnalyticEvent", postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        console.log(type);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_getCurrentBusinessId: function(){
            if(this.CurrentBusiness && this.CurrentBusiness.BusinessID){
                // return this.CurrentBusiness.BusinessID;
                AndroidRoutingTest.setActiveBusinessId(this.CurrentBusiness.BusinessID);
            }
            else{
                return null;
            }
        },

        fn_connectWithClientBusiness: function(business){
            this.connectionTimer = null;
            this.connectionNumber = null;
            
            if(!this.clientConnectionStatus){
                this.showLoading('Connecting...');
            }

            this.$root.fn_getAuthToken(token=>{
                this.hideLoading();
                // if(token == 'error'){
                //     this.hideLoading();
                // }
                if(token != 'error'){

                    this.clientConnectionStatus = 'Connecting';
                    this.$eventHub.$emit('ClientConnectionStatus');

                    //90 seconds timer to clear request if not connected
                    this.connectionTimer = setTimeout(() => {
                        if(this.clientConnectionStatus != "Connected"){
                            console.log("Connection timeout");
                            this.clientConnectionStatus = 'Failed';
                            this.showToast("Connection time out! Try again");
                            this.fn_disconnectClientConnection('timeout');
                        }
                    }, 1.5 * 60 * 1000);

                    let filterObj = {};
                    if(business){
                        let myCurrentBusinessId = this.CurrentBusiness && this.CurrentBusiness.BusinessID ? this.CurrentBusiness.BusinessID : business.BusinessID;
                        filterObj.businessId = business.BusinessID;
                        filterObj.accountantBusinessId = myCurrentBusinessId;
                        localStorage.setItem('recentBusinessObj', JSON.stringify({myBusinessId:myCurrentBusinessId, clientBusinessId:business.BusinessID, clientBusinessName:business.BusinessName, isNewConnection:true}))
                        // localStorage.setItem('recentBusinessObj', JSON.stringify({myBusinessId:this.CurrentBusiness.BusinessID, clientBusinessId:business.BusinessID, clientBusinessName:business.BusinessName}))
                    }
                    else{
                        let recentBusinessObj = JSON.parse(localStorage.getItem('recentBusinessObj'));
                        recentBusinessObj.isNewConnection = false;
                        filterObj.businessId = recentBusinessObj.clientBusinessId;
                        filterObj.accountantBusinessId = recentBusinessObj.myBusinessId;
                        localStorage.setItem('recentBusinessObj', JSON.stringify(recentBusinessObj));
                    }
                    
                    filterObj.token = token;

                    let self = this;
                    this.getFilterData("ConnectWithClientBusiness", null, filterObj,
                        {
                            onSuccess: function(response){
                                console.log(response);
                            }, 
                            onError: function(error){
                                console.log(error);
                                self.clientConnectionStatus = null;
                                self.hideLoading();
                                self.showToast("Something went wrong. Try again");
                            }
                        }
                    );      
                }
            })
        },

        fn_closeLocalDB: function(isNewConnection){
            // let recentBusinessObj = JSON.parse(localStorage.getItem('recentBusinessObj'));
            // let isNewConnection = recentBusinessObj.myBusinessId == this.CurrentBusiness.BusinessID ? true : false;
            let self = this;
            let businessId = this.CurrentBusiness && this.CurrentBusiness.BusinessID ? this.CurrentBusiness.BusinessID : '';
            this.getData('CloseLocalDB', businessId, 
            {
                onSuccess: function(response){
                    console.log(response);
                    self.fn_getBusiness(null, null, ()=>{
                        self.showToast('Logged in with '+self.$root.CurrentBusiness.BusinessName);
                        if(isNewConnection){
                            self.$router.replace('/actions');
                        }
                        else{
                            // going back from webrtc connection view
                            self.$router.go(-1);
                        }
                    });
                },
                onError: function(error){
                    console.log(error);
                    self.showToast("Something went wrong");
                }
            });
        },

        fn_clientConnectionStatus: function(status, connectionId){
            console.log(status);
            if(status == "Connected"){
                this.connectionTimer ? clearTimeout(this.connectionTimer) : '';
                // this.hideLoading();
            }

            this.clientConnectionStatus = status;
            this.$eventHub.$emit('ClientConnectionStatus');
        },

        fn_disconnectClientConnection: function(type, callback){
            let self = this;
            this.getData('DisconnectAccountantClient', null, 
              {
                onSuccess: function(response){
                  console.log(response);
                  let recentBusinessObj = JSON.parse(localStorage.getItem('recentBusinessObj'));
                  if(type != 'timeout'){
                    // in case of user doesn't have any active business
                    if(recentBusinessObj && recentBusinessObj.myBusinessId === recentBusinessObj.clientBusinessId){
                        self.connectionTimer ? clearTimeout(self.connectionTimer) : '';
                        self.clientConnectionStatus = null;
                        self.showToast('Connection aborted');

                        if(type == 'register'){
                            callback ? callback() : '';
                        }
                        else{
                            self.$router.push({path:"/settings/business/items"});
                        }
                    }
                    // in case of user have active business
                    else{
                        self.fn_reopenDatabaseAfterDisconnect(type, callback);
                    }
                  }
                //   callback ? callback() : '';
                },
                onError: function(error){
                  console.log(error);
                  callback ? callback('error') : '';
                  self.showToast('Something went wrong. Try again!.');
                }
            });
        },

        fn_reopenDatabaseAfterDisconnect: function(type, callback){
            let self = this;
            let recentBusinessObj = JSON.parse(localStorage.getItem('recentBusinessObj'));
            if(!recentBusinessObj || !recentBusinessObj.myBusinessId){
                self.exitApp();
            }

            this.getData('ReopenDataBase', recentBusinessObj.myBusinessId, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_getBusiness(null, null, ()=>{
                            self.connectionTimer ? clearTimeout(self.connectionTimer) : '';
                            self.clientConnectionStatus = null;
                            self.showToast('Connection aborted');

                            if(type=='register'){
                                callback ? callback() : '';
                            }
                            else if(type == "Switch Business"){
                                self.$router.push({path:"/settings/business/items"});
                            }
                            else if(self.$root.CurrentBusiness.UserType == 2){
                                if(self.$root.CurrentBusiness.IsAccountantOnly){
                                    self.fn_hideBottomNavigation();
                                }
                                self.$router.push({path:"/settings"});
                            }
                            // else{
                            //     self.$router.replace('/actions');
                            // }
                        });
                        // callback ? callback() : '';
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.exitApp();
                    }
                }
            );
        },

        fn_setConnectionNumber: function(connectionNumber){
            this.$root.connectionNumber = connectionNumber;
        },

        fn_sendPushNotification: function(){
            let postObj = {"title":"Notification Test", "body":"This is notification test body", "actionExtra":"data that required onlick of notification"};
            this.postFilterData('PostNotificationFromWeb', null, postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_openNotification: function(){
            let notificationData = JSON.parse(AndroidRoutingTest.getNotificationData());
            console.log(notificationData);
            // let notificationId = notificationData.actionpath.substring(notificationData.actionpath.lastIndexOf('/')+1);
            // this.$router.push({path:"/notifications/"+this.$root.CurrentBusiness.BusinessID+"/"+notificationId});
            this.$router.push({path:"/notifications/"+this.$root.CurrentBusiness.BusinessID+"/abc"});
        },

        fn_driveError(callbackId, message){
            console.log(callbackId);
            console.log(message);
            if(message.indexOf('User not login to drive') != -1){
                let alertObj = {};
                alertObj.type = 'drive_logout';
                this.$root.CurrentBusiness.DataDrive = null;
                this.$eventHub.$emit('ShowAlert', alertObj); 
            }
        },

        fn_showAlert: function(type, callFromInside){
            console.log('show dialog alert');

            if(callFromInside && localStorage.getItem('donotaskfornotification')){
                localStorage.removeItem('donotaskfornotification');
            }
            
            let alertObj = {};
            alertObj.type = type;
            this.$eventHub.$emit('ShowAlert', alertObj); 
        },

        fn_openThermalView: function () {
            let pageSize = this.ThermalPrintSettings.pageSize ? this.ThermalPrintSettings.pageSize : 3;
            let dataObj = null;
            if(process.env.NODE_ENV === 'production'){
                dataObj = {"printThermalUrl":"https://bizopsapp-thermal-printing.web.app?page_size="+pageSize};
            }
            else{
                dataObj = {"printThermalUrl":"https://bizopsstaging-thermal-printing.web.app?page_size="+pageSize};
            }
            this.postData('LoadThermalPrintApp', dataObj, 
                {
                onSuccess: function(response){
                    console.log(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_getFormNameByListId: function(listId){
            if(listId == 10001 || listId == 10002 || listId == 10003 || listId == 10004 || listId == 10005){
                return 'Sale'
            }
            else if(listId == 20001 || listId == 20002 || listId == 20003 || listId == 20004){
                return 'Purchase'
            }
            else if(listId == 30001){
                return 'Receipt'
            }
            else if(listId == 30002){
                return 'Payment'
            }
        },

        fn_getCreditLabel: function(){
            if(this.TransactionSettings.ledgerCreditDebitLabelType == 2){
                return 'Credit';
            }
            else{
                return 'To Receive';
            }
        },
        
        fn_getDebitLabel: function(){
            if(this.TransactionSettings.ledgerCreditDebitLabelType == 2){
                return 'Debit';
            }
            else{
                return 'To Pay';
            }
        },

        fn_isProductionApp: function(){
            if(process.env.NODE_ENV === 'production'){
                return true;
            }
            else{
                return false;
            }
        },

        fn_whatsAppSupport: function(){
            this.$root.fn_openExternalUrl("https://api.whatsapp.com/send?phone=918882741212");
        },

        fn_settingUpPrintPageSize: function(){

            let style = document.createElement('style');
            style.id = 'dynamic-page-size';

            style.innerHTML = `
                @page {
                    size: A4;
                    margin: 0.5cm 1cm;
                }
            `;

            document.head.appendChild(style);

            // setTimeout(() => {
            //     // Remove old style if exists
            //     const old = document.getElementById('dynamic-page-size');
            //     if (old) old.remove();
            // }, 5000);
        },

        // loading app language from local cache and setting it to vue-i18n
        fn_loadLocale: function(){
            var self = this;
            this.fn_getLocalData('appLanguage', function(response){
                // if(!response || response === 'null') return;
                let langObj = null;
                if(!response || response === 'null'){
                    langObj = { language: 'en' };
                }
                else{
                    try { 
                        langObj = JSON.parse(response); 
                    } catch(e) { 
                        /* plain string */ 
                        console.log('Error parsing JSON:', e);
                    }
                }
                
                // if (!langObj || langObj === 'null' || (langObj && !langObj.language)) return;
                if(langObj.language !== self.selectedLanguage){
                    loadLocale(langObj.language).then(function(){
                        self.selectedLanguage = langObj.language;
                        Validator.localize(langObj.language);
                    });
                }
            });
        }

        // fn_getCurrentBusinessId: function(){
        //     if(this.CurrentBusiness && this.CurrentBusiness.BusinessID){
        //         // return this.CurrentBusiness.BusinessID;
        //         AndroidRoutingTest.setActiveBusinessId(this.CurrentBusiness.BusinessID);
        //     }
        //     else{
        //         return null;
        //     }
        // }

        // fn_test(){
        //     alert('test');
        // }
    },
    computed:{
        batchDateFormat: function(){
            if(this.TransactionSettings.hideMfgExpDay){
                return "MMM-YYYY";
            }
            else{
                return "DD-MMM-YYYY";
            }
        }
    },

    watch: {
        '$root.selectedLanguage': function(lang){
            if(this !== this.$root) return;
            Validator.localize(lang);
            if(this.$validator) this.$validator.errors.clear();
            // Force every screen with a bottom navigation to re-set it on next
            // mount so the menu labels reflect the new language.
            localStorage.removeItem('bottomNavigationSet');
        }
    },

    mounted: function(){
        //do not remove
        //defining global functions for android communication
        window.js_globals.fn_onBackPress;
        window.js_globals.fn_menuItemClick;
        window.js_globals.fn_itemClick;
        window.js_globals.fn_itemSelection;
        window.js_globals.fn_itemRemoveSelection;
        window.js_globals.fn_closeClick;
        window.js_globals.fn_getBottomNavigation;
        window.js_globals.fn_getStatus = this.fn_getStatus;
        window.js_globals.fn_deviceDeactivated = this.fn_deviceDeactivated;
        window.js_globals.fn_setUploadStatus = this.fn_setUploadStatus;
        window.js_globals.fn_getMigrationData = this.fn_getMigrationData;
        window.js_globals.fn_getUqc = this.fn_getUqc;
        window.js_globals.fn_showSnackbarUnreadTickets = this.fn_showSnackbarUnreadTickets;
        window.js_globals.fn_changeDriveAlert = this.fn_changeDriveAlert;
        window.js_globals.fn_showDialogStorageFull = this.fn_showDialogStorageFull;
        window.js_globals.fn_unsyncedItems = this.fn_unsyncedItems;
        window.js_globals.fn_updateMismatchDataDrive = this.fn_updateMismatchDataDrive;
        window.js_globals.fn_getBusiness = this.fn_getBusiness;
        window.js_globals.fn_webRtcConnectionDetails = this.fn_webRtcConnectionDetails;
        window.js_globals.fn_showAlert = this.fn_showAlert;
        window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
        window.js_globals.fn_broadcast = this.fn_broadcast;
        window.js_globals.fn_getTransactionSettings = this.fn_getTransactionSettings;
        window.js_globals.fn_getCurrentBusinessId = this.fn_getCurrentBusinessId;
        window.js_globals.fn_setConnectionNumber = this.fn_setConnectionNumber;
        window.js_globals.fn_clientConnectionStatus = this.fn_clientConnectionStatus;
        window.js_globals.fn_getBusiness = this.fn_getBusiness;
        window.js_globals.fn_openNotification = this.fn_openNotification;
        // window.js_globals.fn_getCurrentBusinessId = this.fn_getCurrentBusinessId;

        console.log('device_info', this.deviceInfo)
        if (this.deviceInfo && this.deviceInfo.DeviceName && this.deviceInfo.DeviceName.indexOf("Apple") != -1) {
            this.platform = "ios"
        }
        /*global AndroidRoutingTest*/
        else if (typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null) {
            this.platform = "android"
        }
        else {
            this.platform = "desktop"
        }
        
        //Init function
        this.fn_init();
        
    }
}


// WEBPACK FOOTER //
// ./src/global_mixin.js